import { onAuthorizationChange,onPersonCenterObjChange } from "./account";

export default {
  onAuthorizationChange,
  onPersonCenterObjChange,
  // onCurrentUserInfoChange,
};
